<div class="flex flex-column w-full h-full align-content-between">
  <div class="flex mb-4 gap-2 w-full">
    <toolbar class="w-full" title="Banques" [actions]="toolbarActions" />
  </div>
  <div class="alm-card p-0 mb-4 border-round-2xl shadow-1 transition-all transition-duration-300 hover:shadow-3 bg-white">
    <div class="bg-white border-round-bottom-xl m-4 border-3 border-gray-100">
      <!-- Formulaire de recherche -->
      <app-search-form
        title="Recherche de banques"
        [data]="banks"
        [dataCopy]="banks"
        [(banksToDisplay)]="banksToDisplay"
        [(pageable)]="pageable"
        [(hasSearched)]="hasSearched"
        [(displaySpinner)]="displaySpinner"
        [(searchForm)]="searchForm"
      ></app-search-form>
    </div>
    <div class="bg-white border-round-bottom-xl m-4 border-3 border-gray-100">
      <dynamic-table [headers]="columns" [data]="banksToDisplay" [pageParams]="pageable"
                    [actions]="actions" (paginate)="onPageChange($event)">
        <div *ngIf="!hasSearched" class="text-center p-5">
          <i class="pi pi-search" style="font-size: 3rem; color: var(--surface-400);"></i>
          <p class="text-xl mt-3" style="color: var(--surface-600);">Veuillez effectuer une recherche pour afficher les banques</p>
        </div>
        <p-progressSpinner [hidden]="!displaySpinner" strokeWidth="2" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px', stoke: '#004F78' }" />
        <div *ngIf="hasSearched && banksToDisplay.length === 0 && !displaySpinner" class="text-center p-5">
          <i class="pi pi-inbox" style="font-size: 3rem; color: var(--surface-400);"></i>
          <p class="text-xl mt-3" style="color: var(--surface-600);">Aucune banque trouvée</p>
        </div>
      </dynamic-table>
    </div>
  </div>
</div>
